module.exports = __webpack_public_path__ + "img/zfr4.1.c314dd81.jpg";